import { createUseStyles } from 'react-jss';

export default createUseStyles({
  button: {
    fontFamily: '"Manrope", sans-serif',
    fontWeight: 800,
    fontSize: '16px',

    background: process.env.REACT_APP_SECONDARY_COLOR,
    cursor: 'pointer',
    zIndex: 10,

    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'middle',
    userSelect: 'none',
    border: 'none',
    height: '56px',
    padding: '0.375rem 0.75rem',
    lineHeight: '1.5',
    borderRadius: '12px',
    transition: 'backgroundColor 0.15s ease-in-out, box-shadow 0.15s ease-in-out',

    textDecoration: 'none',

    boxShadow: '0 20px 10px -15px rgba(246, 246, 247, 0.3)',

    '&:hover': {
      // backgroundColor: '#e5e5e6',
      backgroundColor: 'rgba(16, 33, 49, 0.08)',
      borderColor: 'none',
      textDecoration: 'none',
      color: '#102131',
    },

    '&:active': {
      // background: 'linear-gradient(to right, #D3D3D4, #D3D3D4)',
      backgroundColor: [['rgba(16, 33, 49, 0.08)'], '!important'],
      borderColor: 'none',
      textDecoration: 'none',
      color: [['#102131'], '!important'],
    },

    '&:focus': {
      backgroundColor: process.env.REACT_APP_SECONDARY_COLOR,
      boxShadow: 'none',
      outline: 0,
      textDecoration: 'none',
      color: 'white',
    },
  },
});
